module.exports = __webpack_public_path__ + "img/airbag.91e86657.svg";